import { makeStyles, shorthands } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useDocumentTypeTagStyles = makeStyles({
  pillButton: {
    display: "inline-flex",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[2]),
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    minWidth: "auto",
    height: "auto",
    ...shorthands.borderRadius(designTokens.borderRadius.full),
    ...shorthands.border("1px", "solid", projectIqTokens.line),
    backgroundColor: projectIqTokens.bg2,
    color: projectIqTokens.ink2,
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    transition: `all ${designTokens.transition.fast}`,
    ":hover:not(:disabled)": {
      backgroundColor: projectIqTokens.line2,
    },
    ":disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  addTagButton: {
    display: "inline-flex",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[1]),
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    minWidth: "auto",
    height: "auto",
    ...shorthands.borderRadius(designTokens.borderRadius.full),
    ...shorthands.border("1px", "dashed", projectIqTokens.line),
    backgroundColor: "transparent",
    color: projectIqTokens.faint,
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    transition: `all ${designTokens.transition.fast}`,
    ":hover:not(:disabled)": {
      backgroundColor: projectIqTokens.bg2,
      color: projectIqTokens.ink3,
      ...shorthands.border("1px", "dashed", projectIqTokens.faint),
    },
    ":disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  dot: {
    display: "inline-block",
    width: "8px",
    height: "8px",
    flexShrink: 0,
    ...shorthands.borderRadius(designTokens.borderRadius.full),
  },
  dotColor0: {
    backgroundColor: projectIqTokens.blue,
  },
  dotColor1: {
    backgroundColor: projectIqTokens.amber,
  },
  dotColor2: {
    backgroundColor: projectIqTokens.teal,
  },
  dotColor3: {
    backgroundColor: projectIqTokens.violet,
  },
  dotColor4: {
    backgroundColor: projectIqTokens.green,
  },
  dotColor5: {
    backgroundColor: projectIqTokens.rust,
  },
  menuItemDot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

const DOT_COLOR_CLASS_NAMES = [
  "dotColor0",
  "dotColor1",
  "dotColor2",
  "dotColor3",
  "dotColor4",
  "dotColor5",
] as const;

/**
 * Deterministically picks a dot color for a given tag id, so each tag gets a
 * stable color across renders without needing a per-name mapping.
 */
export const getDocumentTypeDotClassName = (
  styles: ReturnType<typeof useDocumentTypeTagStyles>,
  tagId: string,
): string => {
  if (!tagId) return styles[DOT_COLOR_CLASS_NAMES[0]];
  const charCodeSum = tagId
    .split("")
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
  const index = charCodeSum % DOT_COLOR_CLASS_NAMES.length;
  return styles[DOT_COLOR_CLASS_NAMES[index]];
};
